(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-items"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saberx-cart-lines')) {
  customElements.define('saberx-cart-lines', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        const body = this.querySelector('tbody');
        if (!body) return;
        const rows = [...body.children];
        const sorted = [...rows].sort((a, b) => Number(a.dataset.rewardGift === 'true') - Number(b.dataset.rewardGift === 'true'));
        if (sorted.some((row, index) => row !== rows[index])) body.append(...sorted);
        const form = this.closest('form');
        if (!form || form.dataset.sxGiftOrder === 'true') return;
        form.dataset.sxGiftOrder = 'true';
        form.addEventListener('formdata', (event) => {
          const inputs = [...form.querySelectorAll('input[name="updates[]"][data-index]')];
          if (!inputs.length) return;
          event.formData.delete('updates[]');
          inputs.sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index));
          inputs.forEach((input) => event.formData.append('updates[]', input.value));
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saberx-buying-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saberx-delivery-note')) {
    customElements.define('saberx-delivery-note', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.js-product');
        this.onVariant = (event) => {
          const message = this.querySelector('[data-shipping-eligibility]');
          if (!message) return;
          const variant = event.detail.variant;
          message.textContent = variant && variant.available && variant.requires_shipping && variant.price >= Number(this.dataset.threshold)
            ? this.dataset.qualifiedText : this.dataset.thresholdText;
        };
        this.section?.addEventListener('on:variant:change', this.onVariant);
      }
      disconnectedCallback() { this.section?.removeEventListener('on:variant:change', this.onVariant); }
    });
  }
  if (!customElements.get('saberx-buy-bar')) {
    customElements.define('saberx-buy-bar', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.nativeButton = this.form?.querySelector('[name="add"]');
        if (!this.nativeButton) return;
        this.section = this.form.closest('.js-product');
        this.button = this.querySelector('button');
        this.variant = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        this.optionLabels = JSON.parse(this.querySelector('[data-option-labels]').textContent);
        this.format = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' });
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.onVariant = (event) => { this.variant = event.detail.variant; this.update(); };
        this.onClick = () => {
          if (this.nativeButton.getAttribute('aria-disabled') === 'true') return;
          if (!this.variant?.available || this.nativeButton.disabled) {
            const options = this.section.querySelector('variant-picker') || this.form;
            options.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
            const input = options.querySelector('input:checked, select, button');
            input?.focus({ preventScroll: true });
          } else {
            this.form.requestSubmit(this.nativeButton);
          }
        };
        this.updateVisibility = () => {
          const inputFocused = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]), textarea');
          this.hidden = !this.mobile.matches || !this.passedButton || inputFocused;
          const preview = document.getElementById('PBarNextFrameWrapper');
          const rect = preview?.getBoundingClientRect();
          const offset = rect && rect.height > 0 && rect.top < window.innerHeight && rect.bottom >= window.innerHeight - 2 ? window.innerHeight - rect.top : 0;
          this.style.setProperty('--saberx-preview-offset', `${offset}px`);
          const barRect = this.getBoundingClientRect();
          const clearance = !this.hidden && barRect.height > 0 ? Math.max(0, window.innerHeight - barRect.top) : 0;
          document.documentElement.style.setProperty('--saberx-buy-bar-clearance', `${clearance}px`);
        };
        this.observer = new IntersectionObserver(([entry]) => {
          this.passedButton = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          this.updateVisibility();
        });
        this.observer.observe(this.nativeButton);
        this.layoutObserver = new ResizeObserver(this.updateVisibility);
        this.layoutObserver.observe(this);
        const preview = document.getElementById('PBarNextFrameWrapper');
        if (preview) this.layoutObserver.observe(preview);
        this.buttonObserver = new MutationObserver(() => this.update());
        this.buttonObserver.observe(this.nativeButton, { attributes: true, childList: true, subtree: true });
        this.section.addEventListener('on:variant:change', this.onVariant);
        this.button.addEventListener('click', this.onClick);
        this.mobile.addEventListener('change', this.updateVisibility);
        window.addEventListener('resize', this.updateVisibility);
        document.addEventListener('focusin', this.updateVisibility);
        document.addEventListener('focusout', this.updateVisibility);
        this.update();
      }
      update() {
        const busy = this.nativeButton.getAttribute('aria-disabled') === 'true';
        this.button.disabled = busy;
        this.button.classList.toggle('is-loading', busy);
        this.button.textContent = this.variant?.available && !this.nativeButton.disabled ? this.nativeButton.textContent.trim() : this.dataset.chooseText;
        this.querySelector('.saberx-buy-bar__price').textContent = this.variant ? this.format.format(this.variant.price / 100) : '';
        const coreIndex = Number(this.section.querySelector('[data-core-index]')?.dataset.coreIndex);
        const selectionTitle = this.variant?.options?.map((value, index) => index === coreIndex && value.toLowerCase() === 'profil' ? 'Proffie' : this.optionLabels[index]?.[value] || value).join(' / ') || this.variant?.title;
        this.querySelector('.saberx-buy-bar__selection').textContent = selectionTitle && selectionTitle !== 'Default Title' ? selectionTitle : this.section.querySelector('.product-title')?.textContent.trim();
        this.updateVisibility();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.layoutObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.section?.removeEventListener('on:variant:change', this.onVariant);
        this.button?.removeEventListener('click', this.onClick);
        this.mobile?.removeEventListener('change', this.updateVisibility);
        window.removeEventListener('resize', this.updateVisibility);
        document.removeEventListener('focusin', this.updateVisibility);
        document.removeEventListener('focusout', this.updateVisibility);
        document.documentElement.style.removeProperty('--saberx-buy-bar-clearance');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saberx-cart-discount"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saberx-cart-discount')) {
  class SaberXCartDiscount extends HTMLElement {
    static busy = false;
    static state = null;
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-apply]')) this.update();
        const remove = event.target.closest('[data-code]');
        if (remove) this.update(remove.dataset.code);
      });
      this.querySelector('input').addEventListener('keydown', (event) => {
        if (event.key === 'Enter') { event.preventDefault(); this.update(); }
      });
      this.syncState();
      this.readCart().then((cart) => this.renderCodes(cart)).catch(() => {});
    }
    async readCart() {
      const response = await fetch(`${Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('cart');
      return response.json();
    }
    codes(cart) {
      if (Array.isArray(cart.discount_codes)) return cart.discount_codes;
      const applications = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap((item) => (item.line_level_discount_allocations || []).map((entry) => entry.discount_application))];
      return [...new Set(applications.filter((entry) => ['discount_code', 'code'].includes(entry.type)).map((entry) => entry.title))].map((code) => ({ code, applicable: true }));
    }
    renderCodes(cart) {
      if (!this.isConnected) return;
      const list = this.querySelector('.sx-discount-codes');
      list.replaceChildren();
      this.codes(cart).filter((entry) => entry.applicable !== false).forEach(({ code }) => {
        const item = document.createElement('li');
        const label = document.createElement('span');
        label.textContent = code;
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.code = code;
        button.textContent = this.dataset.remove;
        button.setAttribute('aria-label', `${this.dataset.remove} ${code}`);
        button.disabled = SaberXCartDiscount.busy;
        item.append(label, button); list.append(item);
      });
    }
    syncState() {
      this.setAttribute('aria-busy', String(SaberXCartDiscount.busy));
      this.querySelectorAll('button, input').forEach((element) => { element.disabled = SaberXCartDiscount.busy; });
      const state = SaberXCartDiscount.state;
      if (state) {
        const status = this.querySelector('.sx-discount-status');
        status.textContent = this.dataset[state.key]; status.hidden = false;
        status.dataset.error = String(state.error || false);
        this.querySelector('details').open = state.open;
      }
    }
    static syncAll() { document.querySelectorAll('saberx-cart-discount').forEach((element) => element.syncState()); }
    async update(removeCode) {
      if (SaberXCartDiscount.busy) return;
      const code = this.querySelector('input').value.trim();
      if (!removeCode && !code) {
        SaberXCartDiscount.state = { key: 'empty', error: true, open: true };
        SaberXCartDiscount.syncAll(); return;
      }
      SaberXCartDiscount.busy = true;
      SaberXCartDiscount.state = { key: 'busy', open: true };
      SaberXCartDiscount.syncAll();
      const cartItems = document.querySelector('cart-items');
      try {
        const cart = await this.readCart();
        const previous = this.codes(cart).filter((entry) => entry.applicable !== false).map((entry) => entry.code);
        let codes = removeCode ? previous.filter((value) => value.toLowerCase() !== removeCode.toLowerCase()) : [...previous, code];
        codes = codes.filter((value, index) => codes.findIndex((other) => other.toLowerCase() === value.toLowerCase()) === index);
        const sections = [...new Set(cartItems.getSectionsToRender().map((entry) => entry.section))];
        const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections, sections_url: window.location.pathname })
        });
        if (!response.ok) throw new Error('update');
        const rendered = await response.json();
        const data = await this.readCart();
        data.sections = rendered.sections;
        const accepted = this.codes(data).find((entry) => entry.code.toLowerCase() === code.toLowerCase());
        const allocations = [...(data.cart_level_discount_applications || []), ...data.items.flatMap((item) => (item.line_level_discount_allocations || []).map((entry) => entry.discount_application))];
        const allocated = allocations.some((entry) => String(entry.title || '').toLowerCase() === code.toLowerCase());
        const invalid = !removeCode && (!accepted || accepted.applicable === false);
        SaberXCartDiscount.state = { key: removeCode ? 'removed' : invalid ? 'invalid' : allocated ? 'applied' : 'shipping', error: invalid, open: true };
        await cartItems.refresh(data.sections);
        document.querySelectorAll('saberx-cart-discount').forEach((element) => element.renderCodes(data));
        document.dispatchEvent(new CustomEvent('on:line-item:change', { bubbles: true, detail: { cart: data } }));
      } catch (error) {
        console.error('Saber X cart discount:', error);
        SaberXCartDiscount.state = { key: 'error', error: true, open: true };
      } finally {
        SaberXCartDiscount.busy = false;
        SaberXCartDiscount.syncAll();
        document.querySelector('saberx-cart-discount input')?.focus();
      }
    }
  }
  customElements.define('saberx-cart-discount', SaberXCartDiscount);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saberx-cart-rewards-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saberx-rewards-preview')) {
    customElements.define('saberx-rewards-preview', class extends HTMLElement {
      connectedCallback() {
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: 'CAD' });
        this.onPreview = (event) => this.renderAmount(Number(event.target.value));
        this.querySelector('[data-preview-subtotal]').addEventListener('change', this.onPreview);
        this.renderAmount(Number(this.dataset.subtotal));
      }
      disconnectedCallback() {
        this.querySelector('[data-preview-subtotal]')?.removeEventListener('change', this.onPreview);
      }
      renderAmount(value) {
        const amount = Number.isFinite(value) ? Math.max(0, value) : 0;
        const tiers = [...this.querySelectorAll('[data-threshold]')];
        const next = tiers.find((tier) => Number(tier.dataset.threshold) > amount);
        const message = next ? this.dataset.next.replace('__AMOUNT__', this.money.format((Number(next.dataset.threshold) - amount) / 100)).replace('__REWARD__', next.dataset.reward) : this.dataset.complete;
        this.querySelector('[data-rewards-message]').textContent = message;
        const bar = this.querySelector('[role="progressbar"]');
        bar.style.setProperty('--sx-progress', `${Math.min(amount / 34900 * 100, 100)}%`);
        bar.setAttribute('aria-valuenow', String(Math.min(amount / 100, 349)));
        bar.setAttribute('aria-valuetext', message);
        tiers.forEach((tier) => {
          const unlocked = amount >= Number(tier.dataset.threshold);
          tier.dataset.unlocked = String(unlocked);
          tier.querySelector('[data-tier-state]').textContent = unlocked ? this.dataset.unlocked : this.dataset.locked;
        });
        this.querySelectorAll('[data-gift-threshold]').forEach((choice) => { choice.hidden = amount < Number(choice.dataset.giftThreshold); });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saberx-checkout-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saberx-checkout-guard')) {
  let active = false;
  let pending = 0;
  let timer;
  const buttons = new Map();
  const express = new Map();
  const checkoutSelector = 'button[name="checkout"][form="cart"], button[name="checkout"][form="cart-drawer-form"]';
  const sync = () => {
    document.querySelectorAll('saberx-checkout-guard').forEach((notice) => {
      notice.hidden = !active;
      notice.dataset.pendingRequests = String(pending);
    });
    if (active) {
      document.querySelectorAll(checkoutSelector).forEach((button) => {
        if (!buttons.has(button)) buttons.set(button, button.disabled);
        button.disabled = true;
        button.dataset.sxCartPending = 'true';
        button.setAttribute('aria-busy', 'true');
      });
      document.querySelectorAll('.dynamic-cart-btns').forEach((container) => {
        if (!express.has(container)) express.set(container, container.inert);
        container.inert = true;
        container.setAttribute('aria-busy', 'true');
      });
    } else {
      buttons.forEach((disabled, button) => {
        button.disabled = disabled;
        delete button.dataset.sxCartPending;
        button.removeAttribute('aria-busy');
      });
      express.forEach((inert, container) => {
        container.inert = inert;
        container.removeAttribute('aria-busy');
      });
      buttons.clear(); express.clear();
    }
  };
  const schedule = () => {
    clearTimeout(timer);
    if (pending === 0) timer = setTimeout(() => { active = false; sync(); }, 1200);
  };
  const begin = () => { active = true; sync(); schedule(); };
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    let tracked = false;
    try {
      const input = args[0];
      const url = new URL(input instanceof Request ? input.url : String(input), window.location.href);
      const mutation = /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
      tracked = url.origin === window.location.origin && (mutation || (active && /\/cart\.js$/.test(url.pathname)));
    } catch (error) { tracked = false; }
    if (!tracked) return originalFetch.apply(this, args);
    pending += 1;
    begin();
    const finish = () => { pending -= 1; sync(); schedule(); };
    try {
      return originalFetch.apply(this, args).then((response) => {
        try { response.clone().arrayBuffer().catch(() => {}).finally(finish); } catch (error) { finish(); }
        return response;
      }, (error) => { finish(); throw error; });
    } catch (error) { finish(); throw error; }
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('cart-items') && event.target.closest('button, .js-remove-item')) begin();
    if (event.target.closest('saberx-cart-discount') && event.target.closest('[data-apply], [data-code]')) begin();
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.closest('saberx-cart-discount')) begin();
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.matches('cart-items input[name="updates[]"]')) begin();
  }, true);
  document.addEventListener('submit', (event) => {
    if (active && ['cart', 'cart-drawer-form'].includes(event.target.id)) {
      event.preventDefault(); event.stopImmediatePropagation(); sync();
    }
  }, true);
  document.addEventListener('on:line-item:change', begin);
  window.addEventListener('ProgressBar:cartUpdated', () => { if (active) schedule(); });
  new MutationObserver(() => { if (active) sync(); }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', (event) => { if (event.persisted) begin(); });
  customElements.define('saberx-checkout-guard', class extends HTMLElement {
    connectedCallback() { sync(); }
  });
  begin();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saberx-cro-measurement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saberx-cro-measurement')) {
    customElements.define('saberx-cro-measurement', class extends HTMLElement {
      connectedCallback() {
        this.preview = this.dataset.themeRole !== 'main';
        this.record = (name) => {
          if (Shopify.designMode || typeof window.clarity !== 'function') return;
          const eventName = `saberx_${this.preview ? 'preview_' : ''}${name}`;
          try {
            window.clarity('set', 'saberx_cro_version', '2026-09-13');
            window.clarity('set', 'saberx_theme_role', this.dataset.themeRole);
            window.clarity('event', eventName);
            if (this.preview) console.debug('[SaberX CRO]', eventName);
          } catch (error) {
            if (this.preview) console.debug('[SaberX CRO] Measurement unavailable');
          }
        };
        this.listeners = {
          'on:saberx:cart:add-success': (event) => {
            this.record('add_to_cart_success');
            if (event.target.closest('saberx-display-card, cart-drawer')) this.record('accessory_add_success');
          },
          'on:saberx:cart:add-error': () => this.record('add_to_cart_error'),
          'on:saberx:reviews:open': () => this.record('reviews_open'),
          'on:saberx:gallery:zoom': () => this.record('photo_zoom_open'),
          'submit': (event) => {
            if (event.submitter?.name === 'checkout') this.record('checkout_click');
          },
          'click': (event) => {
            if (event.target.closest('.saberx-card-review-link')) this.record('product_card_reviews_click');
          }
        };
        Object.entries(this.listeners).forEach(([name, handler]) => document.addEventListener(name, handler));
        this.openLinkedReviews = () => {
          if (window.location.hash !== '#judgeme_product_reviews') return;
          const reviews = document.getElementById('judgeme_product_reviews');
          if (!reviews) return;
          reviews.setAttribute('tabindex', '-1');
          reviews.scrollIntoView({ block: 'start' });
          reviews.focus({ preventScroll: true });
          this.record('reviews_open');
        };
        if (document.readyState === 'complete') this.openLinkedReviews();
        else window.addEventListener('load', this.openLinkedReviews, { once: true });
        window.addEventListener('hashchange', this.openLinkedReviews);
        if (this.dataset.pageType === 'product') this.record('product_view');
      }
      disconnectedCallback() {
        Object.entries(this.listeners).forEach(([name, handler]) => document.removeEventListener(name, handler));
        window.removeEventListener('load', this.openLinkedReviews);
        window.removeEventListener('hashchange', this.openLinkedReviews);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saberx-display-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saberx-display-card')) {
    customElements.define('saberx-display-card', class extends HTMLElement {
      connectedCallback() {
        this.onVariantChange = () => {
          const option = this.querySelector('[data-display-variant]')?.selectedOptions[0];
          if (!option) return;
          const price = this.querySelector('[data-display-price]');
          if (price) price.textContent = option.dataset.price;
          this.querySelectorAll('[data-display-link]').forEach((link) => { link.href = option.dataset.url; });
          const image = this.querySelector('.saberx-display-card__image img');
          if (image && option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
        };
        this.addEventListener('change', this.onVariantChange);
        this.onVariantChange();
      }
      disconnectedCallback() { this.removeEventListener('change', this.onVariantChange); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saberx-storefront-focus"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saberx-storefront-focus')) {
    customElements.define('saberx-storefront-focus', class extends HTMLElement {
      connectedCallback() {
        this.root = document.documentElement;
        this.storageKey = 'saberx:promo-dismissed:XHm8Wz';
        this.promoSelector = '[data-kl-scroll-locking-modal]:has([data-testid="klaviyo-form-XHm8Wz"])';
        this.closingPromos = new WeakSet();
        this.dismissed = false;
        this.cartOpening = false;
        try { this.dismissed = sessionStorage.getItem(this.storageKey) === '1'; } catch (error) {}
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        this.onCartOpen = () => { this.cartOpening = true; this.sync(); };
        this.onCartClose = () => { this.cartOpening = false; this.sync(); };
        this.onFormEvent = (event) => {
          if (event.detail?.formId !== 'XHm8Wz') return;
          if (event.detail.type === 'close') this.rememberDismissal();
          else if (event.detail.type === 'open') this.schedule();
        };
        this.onDismissClick = (event) => {
          const button = event.target.closest?.('.klaviyo-close-form');
          if (button?.closest(this.promoSelector) || button?.closest('.kl-teaser-XHm8Wz')) this.rememberDismissal();
        };
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.cartObserver = new MutationObserver(this.schedule);
        document.addEventListener('on:cart-drawer:before-open', this.onCartOpen);
        document.addEventListener('on:cart-drawer:after-close', this.onCartClose);
        document.addEventListener('click', this.onDismissClick, true);
        window.addEventListener('klaviyoForms', this.onFormEvent);
        window.addEventListener('load', this.schedule);
        window.addEventListener('pageshow', this.schedule);
        this.sync();
      }
      rememberDismissal() {
        this.dismissed = true;
        try { sessionStorage.setItem(this.storageKey, '1'); } catch (error) {}
        this.schedule();
      }
      sync() {
        const cart = document.querySelector('cart-drawer');
        if (cart !== this.cart) {
          this.cartObserver.disconnect();
          this.cart = cart;
          if (cart) this.cartObserver.observe(cart, { attributes: true, attributeFilter: ['open'] });
        }
        const inCart = this.hasAttribute('data-cart-page') || this.cartOpening || cart?.hasAttribute('open');
        this.root.toggleAttribute('data-saberx-focus-cart', Boolean(inCart));
        this.root.toggleAttribute('data-saberx-promo-dismissed', this.dismissed);
        document.querySelectorAll('[class*="gw-widget-placeholder-"] > [data-order]').forEach((host) => {
          if (host.shadowRoot?.querySelector('.gw-wl-drawer-button-wrapper')) host.setAttribute('data-saberx-wishlist-launcher', '');
        });
        if (!inCart && !this.dismissed) return;
        document.querySelectorAll(this.promoSelector).forEach((promo) => {
          const close = promo.querySelector('button.klaviyo-close-form');
          if (!close || this.closingPromos.has(promo)) return;
          this.closingPromos.add(promo);
          const focusedInPromo = promo.contains(document.activeElement);
          close.click();
          if (focusedInPromo && cart?.hasAttribute('open')) {
            requestAnimationFrame(() => {
              if (!cart.hasAttribute('open')) return;
              const focusTarget = cart.querySelector('[name="checkout"]:not(:disabled), .js-close-drawer');
              focusTarget?.focus({ preventScroll: true });
            });
          }
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.cartObserver?.disconnect();
        document.removeEventListener('on:cart-drawer:before-open', this.onCartOpen);
        document.removeEventListener('on:cart-drawer:after-close', this.onCartClose);
        document.removeEventListener('click', this.onDismissClick, true);
        window.removeEventListener('klaviyoForms', this.onFormEvent);
        window.removeEventListener('load', this.schedule);
        window.removeEventListener('pageshow', this.schedule);
        this.root.removeAttribute('data-saberx-focus-cart');
        this.root.removeAttribute('data-saberx-promo-dismissed');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["saberx-wishlist-control"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saberx-wishlist-control')) {
    customElements.define('saberx-wishlist-control', class extends HTMLElement {
      connectedCallback() {
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-in-wishlist'] });
        this.sync();
      }
      sync() {
        const button = this.querySelector('button[data-in-wishlist]');
        if (!button) return;
        const saved = button.dataset.inWishlist === 'true';
        const action = saved ? this.dataset.removeLabel : this.dataset.addLabel;
        const label = action + ': ' + this.dataset.productTitle;
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute('title', label);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
